import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import { login, logout } from '../actions/authentication';
import LoginOptions from '../components/login-options';
import { withDefaultStyles } from '../utils/material-ui/hoc';

class Login extends React.Component<any, any> {
    public render() {
        return (
            <div style={this.props.style}>
                <LoginOptions onLogin={this.doLogin} onClose={this.doClose} />
            </div>
        );
    }
    private doLogin = async ({ email, password, setSubmitting }) => {
        this.props.dispatch(await login(email, password));
    }
    private doClose = async () => {
        this.props.dispatch(await logout());
    }
}
const mapStateToProps = (state, ownProps) => {
    return { ...state };
}

export default withDefaultStyles(withRouter(connect(
    mapStateToProps,
)(Login)));



// WEBPACK FOOTER //
// ./src/containers/login.tsx